import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import { Field } from 'react-formality'
import classNames from 'classnames'
import Form from './components/Form'
import connectPropTypes from './utilities/connectPropTypes'
import getField from './utilities/Data/getField'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'

import styles from './EditShape.icss'

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/alt-text */

class EditShape extends React.Component {
	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Your shape') })
		this.props.appShowBottomBar(false)
		this.props.appShowBottomNavBar(true)
		this.props.appBottomNavBarHandleClick(() => {
			this.props.history.goBack()
		})
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	render() {
		const statistics = getField(this.props.user, 'userProfile.statistics')
		return (
			<Form
				onChange={({ values }) => {
					this.props.userProfileStatisticsUpdate({ values })
				}}
				className={classNames(styles.oneColumn)}
				initialValues={{
					stomachShape: getFieldValueInUnit(statistics, 'stomachShape') || 'average',
					chestShape: getFieldValueInUnit(statistics, 'chestShape') || 'average',
					fitPreference: getFieldValueInUnit(statistics, 'fitPreference') || 'average'
				}}
			>
				{props => (
					<React.Fragment>
						<section className={styles.pagePadding}>
							<h2>{this.context.translate('Let\'s capture your shape')}</h2>
							<p>
								{this.context.translate('This helps us calculate a Fitscore (profile completeness) and will make sure you get a great results when you are looking at Kit and Items inside Kitfit')}
							</p>
						</section>
						<section className={classNames(styles.pagePadding, styles.bottomBorder)}>
							<p>{this.context.translate('Your stomach shape')}</p>
							<span className={styles.radioGroup}>
								<img className={styles.radioIcon} src="/images/content/flatBelly.svg" onClick={() => props.store.set('stomach', 'flat')} />
								<img className={styles.radioIcon} src="/images/content/mediumBelly.svg" onClick={() => props.store.set('stomach', 'average')} />
								<img className={styles.radioIcon} src="/images/content/fullBelly.svg" onClick={() => props.store.set('stomach', 'round')} />
							</span>
							<Field
								supportsHelperText={false}
								component={RadioGroup}
								className={styles.radioGroup}
								name="stomachShape"
								value={props.values.stomachShape}
							>
								<FormControlLabel value="flat" control={<Radio color="primary" />} label={this.context.translate('Flat')} />
								<FormControlLabel value="average" control={<Radio color="primary" />} label={this.context.translate('Average')} />
								<FormControlLabel value="round" control={<Radio color="primary" />} label={this.context.translate('Round')} />
							</Field>
						</section>
						<section className={classNames(styles.pagePadding, styles.bottomBorder)}>
							<p>{this.context.translate('Your chest shape')}</p>
							<span className={styles.radioGroup}>
								<img className={styles.radioIcon} src="/images/content/narrowChest.svg" onClick={() => props.store.set('chest', 'narrow')} />
								<img className={styles.radioIcon} src="/images/content/squareChest.svg" onClick={() => props.store.set('chest', 'average')} />
								<img className={styles.radioIcon} src="/images/content/triangleChest.svg" onClick={() => props.store.set('chest', 'broad')} />
							</span>
							<Field
								supportsHelperText={false}
								component={RadioGroup}
								className={styles.radioGroup}
								name="chestShape"
								value={props.values.chestShape}
							>
								<FormControlLabel value="narrow" control={<Radio color="primary" />} label={this.context.translate('Narrow')} />
								<FormControlLabel value="average" control={<Radio color="primary" />} label={this.context.translate('Average')} />
								<FormControlLabel value="broad" control={<Radio color="primary" />} label={this.context.translate('Broad')} />
							</Field>
						</section>
						<section className={styles.pagePadding}>
							<p>{this.context.translate('Your preferred fit tightness')}</p>
							<Field
								supportsHelperText={false}
								component={RadioGroup}
								className={styles.radioGroup}
								name="fitPreference"
								value={props.values.fitPreference}
							>
								<FormControlLabel value="tight" control={<Radio color="primary" />} label={this.context.translate('Tight')} />
								<FormControlLabel value="average" control={<Radio color="primary" />} label={this.context.translate('Average')} />
								<FormControlLabel value="loose" control={<Radio color="primary" />} label={this.context.translate('Loose')} />
							</Field>
						</section>
					</React.Fragment>
				)}
			</Form>
		)
	}
}

EditShape.contextTypes = {
	translate: PropTypes.func
}

EditShape.propTypes = {
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}


export default connectPropTypes(EditShape)



// WEBPACK FOOTER //
// ./src/EditShape.jsx